<span
  [rtTooltip]="time | amDateFormat: amDateFormatPattern"
  [rtTooltipPosition]="tooltipPosition"
  [attr.text-darkest]="colorDarkest ? '' : null"
>
  @if (prefix) {
    {{ prefix }}
  }
  {{ time | rtTimeAgo: timeAgoOptions }}
</span>
